<div class="card text-decoration-none" [style.min-height.px]="c?.minHeight" [ngClass]="{'card-expand':fullScreen, 'bg-emphasis':!fullScreen}">
  <div class="card-body align-items-center text m-3px" *ngIf="c == null">
    Loading...
  </div>
  <div class="card-body align-items-center text m-3px" *ngIf="c">
    
    <div class="d-flex fw-bold small mb-2 text-truncate text-uppercase">
      <span class="flex-grow-1">{{widget.name}}</span>
      <a class="text text-opacity-50 text-decoration-none" (click)="refresh()" data-bs-original-title="" title=""><i class="bi bi-arrow-repeat"></i></a>
      <a data-toggle="card-expand" class="text text-opacity-50 text-decoration-none" (click)="toggleFullScreen()" data-bs-original-title="" title=""><i class="bi bi-fullscreen"></i></a>
    </div>

    <table class="table table-bordered table-stripped" *ngIf="c.showCategories == null || c.showCategories == false; else cattemplate">
      <tr *ngFor="let ts of c.dynamicTimeSeriesList" 
              [class]="'text-' + c.size + ' ' + c.textSize" 
              [class.highlighted]="ts.highlighted || ts.selected"
              (mouseenter)="onRowHover(ts)"
              (mouseleave)="onRowLeave(ts)"
              (click)="onRowClick(ts)">
        <td *ngIf="c.showStatus" style="width:35px">
          <span *ngIf="ts.colour" class="badge" [style.background-color]="ts.colour">&nbsp;</span><span *ngIf="ts.colour == null" class="badge badge-dark">&nbsp;</span>
        </td>
        <td class="text-truncate">
            {{ts.uri == null ? 'Not Set' : ts.dynamicDisplayName == '' || ts.dynamicDisplayName == null ? "..." : ts.dynamicDisplayName}}
        </td>
        <td class="text-end" *ngIf="c.showValue">
          <span *ngIf="ts != null && ts.value != null && !isNaN(ts.value)">
            {{ts.value | number}}<span *ngIf="ts.valueSuffix"> {{ts.valueSuffix}}</span>
          </span>
          <span *ngIf="ts != null && ts.value != null && isNaN(ts.value)">
            {{ts.value}}<span *ngIf="ts.valueSuffix"> {{ts.valueSuffix}}</span>
          </span>
          <span *ngIf="ts == null || ts.value == null">
            ...
          </span>
        </td>
        <td *ngIf="c.showChart" width="40%">
          <ngx-trend [data]="ts.values" height="19" padding="0" autoDraw="true"
            autoDrawDuration="1000"  [gradient]="['#2f7ed8']"
            autoDrawEasing="ease-in"></ngx-trend>
        </td>
      </tr>
    </table>
    
    <ng-template #cattemplate>
      <table class="table table-bordered table-stripped" *ngIf="categories">
        <tr [class]="'text-' + c.size + ' ' + c.textSize">
          <td></td>
          <td *ngFor="let ts of c.dynamicTimeSeriesList">
            {{ts.displayName}}
          </td>
        </tr>
        <tr *ngFor="let cat of categories" [class]="'text-' + c.size + ' ' + c.textSize">
          <td class="text-truncate">{{cat}}</td>
          <td *ngFor="let ts of c.dynamicTimeSeriesList">
            {{ts.value[cat][ts.displayValue]}}
          </td>
        </tr>
      </table>
    </ng-template>
  </div> 
</div> 